module.exports = __webpack_public_path__ + "static/img/IMG_0895.33c3677.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0895.jpeg
// module id = 0uJu
// module chunks = 0